import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import LoadingScreen from '../components/LoadingScreen';
import { PATH_DASHBOARD } from '../routes/paths';
import { isAnnotationWorkspaceOnly } from '../utils/annotationWorkspaceAccess';

export default function AnnotationWorkspaceGuard({ children }) {
  const { isAuthenticated, isInitialized, user } = useAuth();
  const { pathname, search, hash } = useLocation();
  const { workspace } = PATH_DASHBOARD.annotations;
  const normalizedPathname = pathname.replace(/\/+$/, '');

  if (!isInitialized) return <LoadingScreen />;

  if (isAuthenticated && isAnnotationWorkspaceOnly(user) && normalizedPathname !== workspace) {
    const isWorkspaceAlias = normalizedPathname === '/dashboard/annotations/images-v2';
    return <Navigate to={isWorkspaceAlias ? `${workspace}${search}${hash}` : workspace} replace />;
  }

  return children;
}

AnnotationWorkspaceGuard.propTypes = {
  children: PropTypes.node,
};
